<div *ngIf="validateFormGroup()">
    <em *ngFor="let error of getErrors()">
        {{error}}
    </em>
</div>
